import React from 'react';
import PropTypes from 'prop-types';
import { tagQueries } from '../../graphql/queries';
import BBQuery from './BBQuery.js';

// uses render props pattern - https://reactjs.org/docs/render-props.html
// in this case prop is 'children' not 'render' but its the same concept

class Tags extends React.Component {
  render () {
    const { children } = this.props;
    return (
      <BBQuery query={tagQueries.Tags}>
        {data => {
          return children(data.tags);
        }}
      </BBQuery>
    );
  }
}

Tags.propTypes = {
  children: PropTypes.func.isRequired
};

export default Tags;
